import { CircularLoader } from '@northladder/design-system';
import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

/**
 * -----------------------------------------------------------------------------
 * Renders simple badge/pill/label with a loading indicator and text indicating
 * the current image is being uploaded.
 */
export function ImageUploadIndicator() {
  return (
    <span
      className="
        text-primary-700 absolute right-4 top-4 z-[100]  inline-flex items-center
        rounded-full bg-white px-1 py-0.5 text-sm font-medium rtl:left-4 rtl:right-auto
      "
    >
      <CircularLoader className="h-5 w-5" />
      <span className="mx-1">
        <Text text={translations.uploadModalContent.uploadingImage} />
      </span>
    </span>
  );
}
